import { persistStore, persistReducer } from 'redux-persist'
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import authReducer from './slices/authSlice'
import propertyReducer from './slices/propertySlice'
import scheduleReducer from './slices/scheduleSlice'
import billingRerducer from './slices/billingSlice'
import reviewReducer from './slices/reviewSlice'
import chatReducer from './slices/chatSlice'
import dashboardReducer from './slices/dashboardSlice'
import paymentReducer from './slices/paymentSlice'
import notificationReducer from './slices/notificationSlice'
import couponReducer from './slices/couponsSlice'

const authPersistConfig = {
  key: 'userInfo',
  storage,
  whitelist: ['user', 'isSocialLogin']
}

const reducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  dashboard: dashboardReducer,
  property: propertyReducer,
  schedule: scheduleReducer,
  billing: billingRerducer,
  reviews: reviewReducer,
  chat: chatReducer,
  payment: paymentReducer,
  notification: notificationReducer,
  coupons: couponReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout/fulfilled') {
    return { state, auth: { isLoading: false, isSocialLogin: false, user: null, error: null } }
  }
  return reducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer
})

export const persistor = persistStore(store)
